export const EnumLocation = {
  region: "region",
  city: "city",
  district: "district",
  microdistrict: "microdistrict",
  street: "street",
  metroStation: "metroStation",
} as const;

export type LocationEnumType = (typeof EnumLocation)[keyof typeof EnumLocation];
